// ---------------------------------------------------------------------------
// StudioRoot — the app's root composition, extracted from main.tsx so the
// top-level ErrorBoundary mount is unit-testable (F10, Lane 2).
//
// main.tsx has module side effects (registerDefaults(), kg-sw registration)
// and calls createRoot on #root, so it cannot be imported in vitest. This
// component is side-effect-free: importing it only pulls the React tree.
//
// The ErrorBoundary sits OUTSIDE KgProvider deliberately — a render throw
// during provider construction/render is caught here too. The boundary's
// chunk-category auto-reload is one-shot (sessionStorage 'cogo_chunk_reload'
// guard in error-boundary.tsx), so a top-level mount is reload-loop-safe.
//
// NOTE: the boundary's fallback root is `h-full`; it only paints because
// index.css establishes the html/body/#root height:100% chain.
// ---------------------------------------------------------------------------

import { ErrorBoundary } from '@/components/error-boundary'
import { KgProvider } from '@/features/design-system/kg-provider'
import { App } from './App'

export function StudioRoot() {
  return (
    <ErrorBoundary fallbackLabel="Coogo Studio">
      <KgProvider>
        <App />
      </KgProvider>
    </ErrorBoundary>
  )
}
